// Angular
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Afidium
import { ImportBookingComponent } from 'app_sasha/pages/import-booking/import-booking.component';
import { ImportBookingRouting } from 'app_sasha/pages/import-booking/config/import-booking.routing';
import { CardModule } from 'libraries/ui_card/card.module';
import { SashaBreadcrumbModule } from 'app_sasha/shared/components/breadcrumb/sasha-breacrumb.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import { MatRadioModule } from "@angular/material/radio";
import { TextModule } from "libraries/module/formbuilder/fields/text/text.module";
import { UIModule } from "libraries/ui/ui.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { TextareaFieldModule } from "libraries/module/formbuilder/fields/textarea-field/textarea-field.module";
import { FormFieldModule } from "libraries/module/formbuilder/fields/form-field/form-field.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule} from '@angular/material/input';
import { SimpleTextareaFieldModule } from "libraries/module/formbuilder/fields/simple-textarea-field/simple-textarea-field.module";
import { BookingResultsContainerModule } from "app_sasha/pages/booking-search-result/components/booking-results-container/booking-results-container.module";
import { BookingsListModule } from "app_sasha/pages/booking-search-result/components/bookings-list/booking-list.module";
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";
import { CardFormModule } from "libraries/module/formbuilder/forms/card-form/card-form.module";

@NgModule({
    imports: [
        ImportBookingRouting,
        CommonModule,
        CardModule,
        ReactiveFormsModule,
        SashaBreadcrumbModule,
        TitleServiceModule,
        MatRadioModule,
        FormsModule,
        TextModule,
        UIModule,
        LoaderModule,
        NotificationModule,
        TextareaFieldModule,
        FormFieldModule,
        MatFormFieldModule,
        MatInputModule,
        SimpleTextareaFieldModule,
        BookingResultsContainerModule,
        BookingsListModule,
        ComboboxFieldModule,
        CardFormModule,
    ],
    exports: [ImportBookingComponent],
    declarations: [ImportBookingComponent],
})
export class ImportBookingModule { }
